/**
 * Składanie nazwy osoby z imienia i nazwiska.
 *
 * Warstwa wspólna, nie feature: awatary i nagłówki osób stoją zarówno na
 * ekranach zmian rezerwacji, jak i na kartach klienta oraz uczestnika.
 */

/** Inicjały z imienia i nazwiska — awatar osoby. */
export const initialsOf = (firstName: string, lastName: string): string =>
  `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();

/** Imię i nazwisko w jednym napisie. */
export const fullNameOf = (firstName: string, lastName: string): string =>
  `${firstName} ${lastName}`;
